import {Box, CircularProgress} from '@mui/material'
import React from 'react'

const Loader = ({show = false}) => {
    if (!show) return
    return (
        <Box sx={{display: 'flex'}}>
            <CircularProgress size={'30px'} />
        </Box>
    )
}

export default Loader
